// Letter type constants (moved from Coding.constants.ts)
export const LETTER_TYPE_LABEL = {
  unique: "Unique Letter",
  form: "Form Letter",
  added: "Form Plus",
};

export enum LetterType {
  Unique = 'unique',
  Form = 'form',
  Added = 'added'
}

export const DUPLICATE_LETTER_TYPE_CODE = 4;

export const API_BASE_URL = window._env_?.REACT_APP_API_BASE_URL
export const ONELOGIN_AUDIENCE = window._env_?.REACT_APP_ONELOGIN_AUDIENCE || ''
export const ONELOGIN_AUTHORITY = window._env_?.REACT_APP_ONELOGIN_AUTHORITY || ''

// Microsoft Entra ID (MSAL) – used for non-SWCA (agency) user authentication
export const MSAL_CLIENT_ID = window._env_?.REACT_APP_MSAL_CLIENT_ID || ''
export const MSAL_AUTHORITY = window._env_?.REACT_APP_MSAL_AUTHORITY || 'https://login.microsoftonline.com/common'

// System role constants
export const MANAGER_ROLE = 2;

export const DEFAULT_COMMENT_RECORD = {
    parent_id: '',
    letter_type: LetterType.Unique,
    comment_num: 0,
    comment_code: '',
    comment_code_parent: '',
    comment_text: '',
    substantive_code: '',
    attn_flag: false,
    keyword: '',
    possible_sample: false,
    associated_text: '',
    note: '',
    created_by: 0,
    created_on: '',
    created_by_display: '',
    code_by: 0,
  }

  export const DEFAULT_ATTACHMENT_RECORD = {
      attachment_uuid: '',
      n_letters: 0,
      original_filename: '',
      file_size: 0,
      coding_status: '',
      started_by: 0,
      started_on: '',
      started_by_display: '',
      letter_list: ''
    }

export const DEFAULT_EXCEL_COLUMN_WIDTH = 20 //for report excel files

export const STATUS_CODE_PRE_PROCESSING = 1;
export const STATUS_CODE_NOT_STARTED = 2;
export const STATUS_CODE_IN_PROGRESS = 3;
export const STATUS_CODE_NEEDS_ATTENTION = 4;
export const STATUS_CODE_COMPLETE = 5;
export const STATUS_LABEL = {
  [STATUS_CODE_NOT_STARTED]: 'Not Started',
  [STATUS_CODE_NEEDS_ATTENTION]: 'Needs Attention',
  [STATUS_CODE_IN_PROGRESS]: 'In Progress',
  [STATUS_CODE_COMPLETE]: 'Complete'
} as const;

export type StatusCode = keyof typeof STATUS_LABEL;